<template>
    <div>
        <h1 class="text-center c-orange mb-5">Parabéns!</h1>
        <h2 class="text-center">Você já pode comemorar, seu aplicativo já está disponível para download.</h2>
    </div>
</template>
<script>
export default {

}
</script>